















































































import { Component, Provide, Vue } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';
import Constants from '@/constants';

@Component({
  props: ['organizationId'],
})
export default class ExportModal extends Vue {
  @Provide()
  isFullExport: boolean = false;
  isExportProcessed: boolean = false;
  isExportFail: boolean = false;
  request: any = null;
  date: any = null;
  groupSize: number = 6;
  @Provide() parentValidator = this.$validator;
  moment = moment;

  mounted() {
    axios.get('/Settings/FmbaDate')
      .then((res) => {
        if(res.data) {
          this.date = moment(res.data, 'DD.MM.YYYY HH:mm').toISOString();
        }
      });
  }

  dateChanged(e: any) {
    this.date = moment(e).toISOString();
  }

  showModal() {    
    this.isExportProcessed = false;
    this.isExportFail = false;
    this.$root.$emit('bv::show::modal', 'export-fmba-donors-modal');
  }

  hideModal() {
    if (this.request) {
      this.request.cancel('user_cancel');
    }

    this.$root.$emit('bv::hide::modal', 'export-fmba-donors-modal');
    this.$emit('closeModal');
  }

  get exportUrl() {
    let query = this.isFullExport ? '' : '?date=' + this.date;
    return Constants.baseUrl + '/donors/ExportFmba' + query;
  }

  exportDonors() {
    const CancelToken = axios.CancelToken;

    this.request = CancelToken.source();
    this.isExportProcessed = true;
    this.isExportFail = false;

    axios({
      url: this.exportUrl,
      method: 'GET',
      responseType: 'blob',
      cancelToken: this.request.token,
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        const fileName = `FMBA_${moment().format('YYYYMMDD')}.csv`;

        this.isExportProcessed = false;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        this.date = moment(response.headers['exportdate'], 'DD.MM.YYYY HH:mm').toISOString();
        this.hideModal();
        //@ts-ignore
        this.$swal({ title: this.$t('Экспортировано') + ` ${response.headers['donorscount']} ` + this.$t('записей'), icon: "success" });
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          this.isExportFail = true;
          this.isExportProcessed = false;
        }
      });
  }
}
